"use strict" ;

/**
 * The collection representation of all ASCII symbols characters.
 * @name symbols
 * @memberof core.chars
 * @const
 * @type {Array}
 * @instance
 */
const symbols =
[
    " "  , // The "space" unicode character
    "!"  , // The "!" unicode character
    "\"" , // The quotation marks
    "#"  , // The number sign
    "$"  , // The "$" unicode character
    "%"  , // The percent unicode character
    "&"  , // The ampersand unicode character
    "\'" , // The apostrophe unicode character
    "("  , // The "(" unicode character
    ")"  , // The ")" unicode character
    "*"  , // The asterisk closing single quotation mark, acute accent unicode character
    "+"  , // The plus unicode character
    ","  , // The comma unicode character
    "-"  , // The minus (hyphen) unicode character
    "."  , // The decimal point (period) unicode character
    "/"  , // The slash (slant) unicode character
    ":"  , // The colon ":" unicode character
    ";"  , // The semi colon ";" unicode character
    "<"  , // The lessThan "&lt;" unicode character.
    "="  , // The equals unicode character
    ">"  , // The greaterThen "&gt;" unicode character
    "?"  , // The questionMark "?" unicode character
    "@"  , // The commercial at "@" unicode character
    "["  , // The opening bracket "[" unicode character
    "\\" , // The backslash (reverse slant) "\\" unicode character
    "]"  , // The closing bracket "]" unicode character
    "^"  , // The circumflex "^" unicode character
    "_"  , // The underline "_" unicode character
    "`"  , // The grave accent "`" unicode character
    "{"  , // The opening brace "{" unicode character
    "|"  , // The pipe (vertical line) "|" unicode character
    "}"  , // The closing brace "}" unicode character
    "~"  , // The tilde "~" pr "-" over line, general accent unicode character
];

export default symbols ;